import dayjs from 'dayjs';
import type { WorkbenchState } from './types';

export const DEFAULT_MODULE_ORDER = [
  'tasks',
  'schedule',
  'highlights',
  'focus',
  'risks',
  'activities',
  'quickActions',
  'businessApps',
];

/** 运行时初始态：空壳，页面数据由工作台汇总 API 填充，避免演示 mock 混入真实待办。 */
export const createEmptyState = (now = new Date()): WorkbenchState => ({
  schemaVersion: 1,
  generatedAt: now.toISOString(),
  sourceEntities: [],
  workItems: [],
  schedules: [],
  focusObjects: [],
  reminders: [],
  activities: [],
  preference: {
    roleView: 'investmentManager',
    moduleOrder: DEFAULT_MODULE_ORDER,
    hiddenModules: [],
    reminderPreferences: {
      highRisk: true,
      taskDue: true,
      meeting: true,
      decision: true,
      payment: true,
      reporting: true,
      focusedEntity: true,
    },
    homeScope: 'mine',
  },
  viewState: {
    workItemTab: 'all',
    activityTab: 'all',
    focusTab: 'all',
    scheduleView: 'week',
    filters: {},
    scrollPositions: {},
  },
});
